import axios from "axios";
import { BASE_URL_STRING } from "./axios";

export const BASE_URL = BASE_URL_STRING;
export const EndPoints = {
  getStudentById: (id) => `dashboard/students/id/${id}/`,
  searchStudents: "dashboard/students/search",
  toggleStudentStatus: "dashboard/students/toggle-status/",
  addStudent: "dashboard/students/create",
  getStudentQRCode: (id) => `dashboard/students/${id}/qrcode`,
  exportQrCodes: "dashboard/students/export-qrcodes",
  attendance: "dashboard/students/scan-attendance",
  attendanceReport: "dashboard/students/attendance-report",
  editStudent: (id) => `dashboard/students/${id}/edit`,
  getMonthlyStudentReport: (studentId, year, month) =>
    `dashboard/students/${studentId}/monthly-report?year=${year}&month=${month}`,
};

export const createStudentsAPIEndpoint = (endpoint) => {
  let url = BASE_URL + "v1/" + endpoint + "";
  const token = sessionStorage.getItem("token");
  return {
    fetch: (options) =>
      axios.get(url, {
        ...options,
        headers: { Authorization: `Bearer ${token}` },
      }),

    fetchById: (id) =>
      axios.get(url + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    post: (newRecord) => axios.post(url, newRecord),

    deleteWithID: (id) =>
      axios.delete(url + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    delete: () =>
      axios.delete(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    postWithToken: (newRecord) =>
      axios.post(url, newRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    put: (updatedRecord) =>
      axios.put(url, updatedRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    putById: (id, updatedRecord) =>
      axios.put(url + id, updatedRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
  };
};
